<template>
    <v-app>
        <NavMain v-if="$store.state.loggedIn" />
        <v-app-bar app v-if="$store.state.loggedIn">
            <v-app-bar-nav-icon @click="$store.commit('toggleNav')" />
            {{ $route.name }}
            <v-spacer />
            <v-img
                src="https://res.cloudinary.com/campusedu/image/upload/v1605047001/campus-logos/CampusLogo.3-1_i6oeos.png"
                max-height="100%"
                max-width="100px"
            />
        </v-app-bar>
        <v-main transition="fade-transition">
            <v-container>
                <router-view />
            </v-container>
        </v-main>
    </v-app>
</template>

<script>
import NavMain from "@/components/NavMain";

export default {
    name: "App",
    components: {
        NavMain
    }
};
</script>
